module.exports = __webpack_public_path__ + "assets/img/title-676bff5b.png";